document.addEventListener('DOMContentLoaded', () => {
  function _doInit(swiperObj) {

  }

  function _doBlockCarousel(block, type) {
    const blockId = block.dataset.blockId

    const option = {
      init: false,
      spaceBetween: 10,
      slidesPerView: 1.1,
      preventClicks: false,
      preventClicksPropagation: false,
      slidesOffsetAfter: 20,
      slidesOffsetBefore: 20,
      pagination: {
        el: block.querySelector('.swiper-pagination'),
        type: 'progressbar',
        clickable: false
      },
      breakpoints: {
        500: {
          slidesPerView: 1.75
        },
        750: {
          slidesPerView: 2.2
        },
        990: {
          slidesPerView: 1,
          spaceBetween: 0,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0,
          pagination: {
            el: block.querySelector('.swiper-pagination'),
            type: 'bullets',
            clickable: true
          },
        }
      }
    }

    const swiperObj = new Swiper(`.js-two-half-block-carousel-${blockId}[on-${type}]`, option)
    swiperObj.on('init', _doInit(swiperObj))
    swiperObj.on('resize', (swiper) => {
      _doInit(swiper)
    })
    swiperObj.init()
  }

  function _doCarousel(block) {
    const sectionId = block.dataset.sectionId

    const option = {
      init: false,
      spaceBetween: 0,
      slidesPerView: 1,
      preventClicks: false,
      preventClicksPropagation: false,
      slidesOffsetAfter: 0,
      slidesOffsetBefore: 0,
      navigation: {
        nextEl: '.carousel--icon-next',
        prevEl: '.carousel--icon-previous',
      }
    }

    const swiperObj = new Swiper(`.js-two-half-carousel-${sectionId}`, option)
    swiperObj.on('init', _doInit(swiperObj))
    swiperObj.on('resize', (swiper) => {
      _doInit(swiper)
    })
    swiperObj.init()
  }

  function buildTwoHalfCarousel() {
    const $blocksMobile = document.querySelectorAll('.js-two-half-block-wrapper[on-mobile]')
    for (const $block of $blocksMobile) {
      const blockId = $block.dataset.blockId
      if (!blockId || !/^[a-zA-Z0-9_-]+$/.test(blockId)) {
        console.warn('Invalid or missing blockId:', blockId)
        continue
      }
      const carouselElem = $block.querySelector(`.js-two-half-block-carousel-${blockId}[on-mobile]`)
      if (carouselElem) {
        _doBlockCarousel($block, 'mobile')
      }
    }

    const $blocksDesktop = document.querySelectorAll('.js-two-half-block-wrapper[on-desktop]')
    for (const $block of $blocksDesktop) {
      const blockId = $block.dataset.blockId
      const carouselElem = $block.querySelector(`.js-two-half-block-carousel-${blockId}[on-desktop]`)
      if (carouselElem) {
        _doBlockCarousel($block, 'desktop')
      }
    }

    const $carousels = document.querySelectorAll('.js-two-half-wrapper')
    for (const $carousel of $carousels) {
      const sectionId = $carousel.dataset.sectionId
      const carouselElem = $carousel.querySelector(`.js-two-half-carousel-${sectionId}`)
      if (carouselElem) {
        _doCarousel($carousel)
      }
    }
  }

  buildTwoHalfCarousel()

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:select', buildTwoHalfCarousel)
  }
})
